export default __webpack_public_path__ + "static/media/iconmonstr-discord-1.3d30be9f.svg";